/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/scripts/sections/image_banner.js ***!
  \**********************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var imageBanner = function imageBanner(index) {
  return {
    imageBanner: null,
    bannerMedia: null,
    headerGroup: null,
    announcementBar: null,
    headerHeight: 0,
    template: null,
    init: function init() {
      var _this = this;
      window.addEventListener("load", function () {
        _this.template = document.querySelector("main").getAttribute("data-template");
        _this.imageBanner = document.querySelectorAll(".image-banner__section");
        _this.announcementBar = document.querySelector(".announcement-bar");
        _this.headerGroup = document.querySelector(".header-group");
        if (_this.headerGroup) {
          if (_this.announcementBar) {
            _this.headerHeight = _this.announcementBar.offsetHeight + _this.headerGroup.offsetHeight;
          } else {
            _this.headerHeight = _this.headerGroup.offsetHeight;
          }
        }
      });
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (imageBanner);
document.addEventListener("alpine:init", function () {
  Alpine.data("imageBanner", imageBanner);
});
/******/ })()
;